import React from 'react';
import { compose, is } from 'ramda';
import { Map } from 'immutable';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './AvailMainSideSummaryTotalPrice.js';
import { RichText } from '@synergycms_core/components/generic';
import connect from 'react-redux/es/connect/connect';
import Price from '@synergycms_core/components/generic/Price';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import { EquivalentPrice } from '../../CustomerForm/SmallComponents';


const AvailMainSideSummaryTotalPrice = class AvailMainSideSummaryTotalPrice extends React.Component {
  static displayName = 'AvailMainSideSummaryTotalPrice';

  render() {
    const { config, theme } = this.props,
      {
        totalPrice,
        stepCode,
        text,
        summaryPriceBreakdown,
        hotelCurrencyCode,
        currentCurrencyCode,
        payments
      } = config;

    const { classes } = theme.styles;
    const showEquivalentPrice = summaryPriceBreakdown && currentCurrencyCode !== hotelCurrencyCode && stepCode !== 'confirmation' && stepCode !== 'newCof';

    return (
      <div className={classes.contentModule}>
        <div className={classes.contentModuleRow}>
          <div className={classes.contentModuleCell}>
            <RichText text={text} ucFirst={true} translate={true} />
          </div>
          <div className={[classes.contentModuleCell, classes.contentModuleCellPrice].join(' ')}>
            <Price
              amount={totalPrice}
              forceHotelCurrency={stepCode === 'confirmation'}
            />
          </div>
        </div>
        {showEquivalentPrice &&
          <div className={classes.equivalentBlock}>
              <EquivalentPrice
                hotelCurrencyCode={hotelCurrencyCode}
                currentCurrencyCode={currentCurrencyCode}
                totalPrice={totalPrice}
              />
          </div>
        }
      </div>
    )
  }
};

const mapStateToProps = (store, ownProps) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const hotelInfo = store.getIn(['hotels', hotelId]);
  const hotel = is(Map, hotelInfo) && hotelInfo.size > 0 && hotelInfo.get('name') && hotelInfo;

  return {
    stepCode: store.getIn(['customer', 'step', 'current_step', 'code']),
    summaryPriceBreakdown: hotel && hotel.get('summary_price_breakdown', false),
    hotelCurrencyCode: store.getIn(['hotels', hotelId, 'currency', 'code']),
    currentCurrencyCode: store.getIn(['customer', 'current_currency']) || undefined,
  };
};

export default compose(
  validateAsyncComponent(mapStateToProps),
  connect(
    mapStateToProps,
  ),
  PropertyManager([
    'totalPrice',
    'stepCode',
    'text',
    'summaryPriceBreakdown',
    'hotelCurrencyCode',
    'currentCurrencyCode',
    'payments'
  ]),
  withThemeJSS({ styleFile, link: true }),
  withContent('i18n')
)(AvailMainSideSummaryTotalPrice);
